<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
export default {
    name: "App",
    components: {},
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = to.meta.title || "Smiley Tools - Temasek Club";
            }
        }
    },
    data: () => ({
        //
    })
};
</script>

<style>
.tm-pointer {
    cursor: pointer;
}
</style>